import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { IconClock } from '@tabler/icons-react';

/**
 * DealTimer Component
 * Shows a live countdown for active Hot Deals
 * @param {string} endDate - Expiry date of the deal
 * @param {string} label - Optional deal label (e.g. "56% OFF")
 * @param {string} variant - 'mini' (for cards), 'medium' (for cards/cart with background), or 'large' (for single page)
 */
const DealTimer = ({ endDate, label, variant = 'mini' }) => {
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        if (!endDate) return;

        const calculateTimeLeft = () => {
            const end = moment(endDate);
            const now = moment();

            if (now.isAfter(end)) {
                setTimeLeft('Expired');
                return;
            }

            const diff = end.diff(now);
            const duration = moment.duration(diff);

            const hours = Math.floor(duration.asHours());
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            if (variant === 'mini') {
                if (hours > 0) {
                    setTimeLeft(`${hours}h ${minutes}m left`);
                } else if (minutes > 0) {
                    setTimeLeft(`${minutes}m left`);
                } else {
                    setTimeLeft(`${seconds}s left`);
                }
            } else {
                // Large format for single page
                const remainingHours = hours > 24 ? hours % 24 : hours;
                setTimeLeft(`${remainingHours}h ${minutes}m ${seconds}s`);
            }
        };

        calculateTimeLeft();
        const interval = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(interval);
    }, [endDate, variant]);

    if (!endDate || timeLeft === 'Expired') return null;

    const isLarge = variant === 'large';
    const isMedium = variant === 'medium';
    const isProminent = isLarge || isMedium;

    return (
        <div className={`deal-timer-container ${variant} pcu-flex pcu-items-center pcu-gap-6 pcu-font-700 pcu-color-error pcu-radius-6 ${isLarge ? 'pcu-font-16 pcu-padding-x-12 pcu-padding-y-8 pcu-margin-top-10' : isMedium ? 'pcu-font-12 pcu-padding-x-10 pcu-padding-y-4 pcu-margin-top-6' : 'pcu-font-11 pcu-margin-top-4'} ${isProminent ? 'pcu-bg-error-light pcu-border-error-light pcu-w-fit' : 'pcu-bg-transparent pcu-border-none pcu-w-auto'}`}>
            <IconClock size={isLarge ? 18 : isMedium ? 16 : 14} />
            {isProminent && <span className="pcu-margin-right-4">Offer ends in:</span>}
            <span>{timeLeft}</span>
            {label && !isProminent && <span className="pcu-margin-left-4 pcu-opacity-80">({label})</span>}
        </div>
    );
};

export default DealTimer;
